import { X } from 'lucide-react';

export function PageHeader({ icon: Icon, leading, title, subtitle, actions }) {
  return (
    <header className="page-header">
      <div className="d-flex align-items-start gap-3">
        {leading || (Icon && <span className="page-heading-icon"><Icon className="icon-lg" aria-hidden="true" /></span>)}
        <div>
          <h1 className="page-title">{title}</h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  );
}

export function Surface({ title, icon: Icon, action, children, className = '', accent }) {
  return (
    <section className={`surface-card ${className}`} style={accent ? { '--card-accent': accent } : undefined}>
      {title && (
        <div className="surface-header d-flex align-items-center justify-content-between gap-3">
          <span className="d-flex align-items-center gap-2">
            {Icon && <Icon className="icon text-primary" aria-hidden="true" />}
            {title}
          </span>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function StatCard({ label, value, icon: Icon, tone = 'accent', sub }) {
  return (
    <div className={`stat-card tone-${tone}`}>
      {Icon && <span className="stat-icon"><Icon className="icon-lg" aria-hidden="true" /></span>}
      <div className="stat-value">{value ?? '—'}</div>
      <div className="stat-label">{label}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}

export function StatusBadge({ children, tone = 'muted', dot = true }) {
  return <span className={`status-badge tone-${tone}`}>{dot && <span className="status-dot" aria-hidden="true" />}{children}</span>;
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="empty-state">
      {Icon && <Icon className="empty-state-icon" aria-hidden="true" />}
      <div className="empty-state-title">{title}</div>
      {hint && <div className="empty-state-hint">{hint}</div>}
    </div>
  );
}

export function Modal({ title, onClose, children, labelledBy = 'dialog-title', wide = false }) {
  return (
    <div className="modal-shell" role="presentation" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className={`modal-panel${wide ? ' modal-panel-wide' : ''}`} role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
        <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
          <h2 id={labelledBy} className="modal-title mb-0">{title}</h2>
          <button type="button" className="icon-btn" onClick={onClose} aria-label="Close"><X className="icon-lg" aria-hidden="true" /></button>
        </div>
        {children}
      </section>
    </div>
  );
}

export function InfoRow({ label, children }) {
  return <div className="info-row"><div className="info-label">{label}</div><div className="info-value">{children}</div></div>;
}
